export default [
  {
    'text': '적립',
    'state': 'ADD'
  },
  {
    'text': '차감',
    'state': 'USE'
  }
];



// WEBPACK FOOTER //
// ./src/api/pointType.js